import React from "react";
import PropTypes from "prop-types";
import GameContainer from "../containers/SplitSecond/GameContainer";

import './GameScreen.css';
import { useState } from "react";
import { useEffect } from "react";

const GameScreen = props => {

  const { transitionOut, delay } = props;
  let [gameScreenClassName, setGameScreenClassName] = useState('');

  const handleTransitionOut = ()=>{
    console.log('handleTransitionOut');
    setGameScreenClassName(' transition-out');
  }

  const handleAnimationEnd = evt=>{
    const { animationName } = evt;

    if (animationName === 'fade-out') {
      transitionOut();
    } 
  }

  useEffect(()=>{

  }, [gameScreenClassName]);

  return (
    <div className={'game-screen' + gameScreenClassName}  onAnimationEnd={handleAnimationEnd} >
      <div className="game-container">
        <GameContainer transitionOut={transitionOut}/>
      </div>
    </div>
  );
};

GameScreen.propTypes = {
  transitionOut: PropTypes.func.isRequired,
  delay: PropTypes.number
};

export default GameScreen;
